module.exports = __webpack_public_path__ + "assets/img/company.f655ece2.svg";